/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/substring.json`.

import type { FunctionDefinition } from '../../definition_types';

/**
 * Returns a substring of a string, specified by a start position and an optional length.
 *
 * @example
 * FROM employees
 * | KEEP last_name
 * | EVAL ln_sub = SUBSTRING(last_name, 1, 3)
 *
 * @example
 * FROM employees
 * | KEEP last_name
 * | EVAL ln_sub = SUBSTRING(last_name, -3, 3)
 *
 * @example
 * FROM employees
 * | KEEP last_name
 * | EVAL ln_sub = SUBSTRING(last_name, 2)
 */
const definition: FunctionDefinition = {
  type: 'scalar',
  name: 'substring',
  signatures: [
    {
      params: [
        {
          name: 'string',
          type: 'keyword',
          optional: false,
        },
        {
          name: 'start',
          type: 'integer',
          optional: false,
        },
        {
          name: 'length',
          type: 'integer',
          optional: true,
        },
      ],
      variadic: false,
      returnType: 'keyword',
    },
    {
      params: [
        {
          name: 'string',
          type: 'text',
          optional: false,
        },
        {
          name: 'start',
          type: 'integer',
          optional: false,
        },
        {
          name: 'length',
          type: 'integer',
          optional: true,
        },
      ],
      variadic: false,
      returnType: 'keyword',
    },
  ],
  preview: false,
  snapshotOnly: false,
};

export default definition;
